export default __webpack_public_path__ + "static/media/Group 11910.3300cfb7.svg";